import classNames from 'classnames';
import { useState } from 'react';

export function Favicon({ domain, className }) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  const parsedDomain = domain.replace(/\.\*$/, '.com');
  const src = `https://favicons.crazyegg.com/favicon/${parsedDomain}`;

  if (error) return null;

  return (
    <img
      className={classNames(`h-4 w-4 rounded transition-opacity duration-200`, loaded ? 'block' : 'hidden', className)}
      onLoad={() => setLoaded(true)}
      onError={() => setError(true)}
      src={src}
      alt={`${domain} favicon`}
    />
  );
}
